import * as types from '../actions/actionTypes';

export const startImagingWorkflow = () => ({ type: types.IMAGE_WORKFLOW_STARTED });
export const finishImagingWorkflow = () => ({ type: types.IMAGE_WORKFLOW_FINISHED });
export const abandonImagingWorkflow = () => ({ type: types.IMAGE_WORKFLOW_ABANDONED });

export const startCloningWorkflow = () => ({ type: types.CLONE_WORKFLOW_STARTED });
export const finishCloningWorkflow = () => ({ type: types.CLONE_WORKFLOW_FINISHED });
export const abandonCloningWorkflow = () => ({ type: types.CLONE_WORKFLOW_ABANDONED });


// WEBPACK FOOTER //
// ./src/js/actions/workflowActionCreators.js